import { Injectable, EventEmitter } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';

@Injectable({
  providedIn: 'root'
})
export class ShowhideService {
    visible: boolean;
    visibleCreateButton: boolean = true;

    visibleIcon: boolean;
    private change_visible_emitter: EventEmitter<boolean> = new EventEmitter<boolean>();
    private footer_visible_emitter: EventEmitter<boolean> = new EventEmitter<boolean>();
    private whoooshie_visible_emitter: EventEmitter<boolean> = new EventEmitter<boolean>();
    private tabDashboard_visible_emitter: EventEmitter<boolean> = new EventEmitter<boolean>();
    private tabDashboard_sendLink_emitter: EventEmitter<string> = new EventEmitter<string>();
    private change_visible_icon_emitter: EventEmitter<boolean> = new EventEmitter<boolean>();
    private sendSaveBoardEmitter: EventEmitter<boolean> = new EventEmitter<boolean>();
    private openMenu_emitter: EventEmitter<boolean> = new EventEmitter<boolean>();
    private openPlaylist_emitter: EventEmitter<boolean> = new EventEmitter<boolean>();
    private openCommentMenu_emitter: EventEmitter<boolean> = new EventEmitter<boolean>();
    public sideNav:MatSidenav;
    public sideNavMenu:MatSidenav;



        constructor() {
            this.visible = false;
            this.footer_visible_emitter.emit(true);
            this.change_visible_emitter.emit(true);
            this.tabDashboard_visible_emitter.emit(false);
            this.openMenu_emitter.emit(false);
            this.openPlaylist_emitter.emit(false);
            this.whoooshie_visible_emitter.emit(true);


        }
        getLinkfromTab(){
            this.tabDashboard_sendLink_emitter.emit('all');
        }

        sendLinkfromTab(link:string){
            this.tabDashboard_sendLink_emitter.emit(link);
        }
        sendSaveBoard(){
            this.sendSaveBoardEmitter.emit(true);
        }
        openMenuOnClick(state:boolean){
                this.openMenu_emitter.emit(true);
        }
        openPlaylistOnClick(state:boolean){
                this.openPlaylist_emitter.emit(state);
        }
        openCommentMenuOnClick(state:boolean){
                this.openCommentMenu_emitter.emit(true);
        }
        closeMenuOnClick(state:boolean){
                this.openMenu_emitter.emit(state);
        }

        hideTabDashboard() {
            this.tabDashboard_visible_emitter.emit(false);
        }
        showTabDashboard() {
            this.tabDashboard_visible_emitter.emit(true);
        }

        hidefooter(){
            this.footer_visible_emitter.emit(false)
        }
        showfooter(){
            this.footer_visible_emitter.emit(true)
        }
        showWhoooshie(){
            this.whoooshie_visible_emitter.emit(true)
        }
        hideWhoooshie(){
            this.whoooshie_visible_emitter.emit(false)
        }
        hide() {
            this.change_visible_emitter.emit(false);
        }

        show() {
            this.change_visible_emitter.emit(true);
        }
        showCreateButton() {
            this.visibleCreateButton = true;
        }
        hideCreateButton() {
            this.visibleCreateButton = false;
        }
        showIcon() {
            this.change_visible_icon_emitter.emit(true);
        }

        hideIcon() {
            this.change_visible_icon_emitter.emit(false);
        }

        toggle() {
            this.visible = !this.visible;
        }

        doSomethingElseUseful() {
        }

        public sendSaveBoardOnClick():EventEmitter<boolean>{
            return this.sendSaveBoardEmitter;
        }

        public getVisibleEmitter():EventEmitter<boolean>{
            return this.change_visible_emitter;
        }

        public getTabDashboardEmitter():EventEmitter<boolean>{
            return this.tabDashboard_visible_emitter;
        }

        public getVisibleIconEmitter():EventEmitter<boolean>{
            return this.change_visible_icon_emitter;
        }

        public openMenuEmitter():EventEmitter<boolean>{
            return this.openMenu_emitter;
        }
        public openMenuCommentEmitter():EventEmitter<boolean>{
            return this.openCommentMenu_emitter;
        }
        public openPlaylistEmitter():EventEmitter<boolean>{
            return this.openPlaylist_emitter;
        }

        public getVisibleCreateButton():boolean{
            return this.visibleCreateButton;
        }
        public getLinkFromTabBar():EventEmitter<string>{
            return this.tabDashboard_sendLink_emitter;
        }
        public getFooterShowEmitter():EventEmitter<boolean>{
            return this.footer_visible_emitter;
        }
        public getWhoooshieShowEmitter():EventEmitter<boolean>{
            return this.whoooshie_visible_emitter;
        }

    }
